import {Grid, CssBaseline, Box} from "@mui/material";
import {Outlet} from "react-router-dom";
import Slidebar_Dashboard from "./Slidebar_Dashboard";

const LayoutDashboard = () => {
    return (
        <Grid container
              justifyContent={'center'}
              alignItems={'flex-start'}
              size={{xs: 12, sm: 12, md: 12}}
              sx={{zIndex: 2, pt: 11}}
        >
            <Grid container
                  justifyContent={'flex-start'}
                  alignItems={'flex-start'}
                  size={{xs: 12, sm: 12, md: 12}}>
                <Slidebar_Dashboard/>
            </Grid>
            <Grid container
                  justifyContent={'center'}
                  alignItems={'flex-start'}
                  size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      overflowY: "auto", // 👈 aquí se genera el scroll
                      p: 0,
                  }}>
                <Outlet/>
            </Grid>
        </Grid>
    );
};

export default LayoutDashboard;